import { useInfiniteQuery } from '@tanstack/vue-query';
import type { Service, ServiceFilters } from '../types';
import { serviceKeys } from './keys';

import { tryGetNextPage } from '@glow/shared/lib/vueQuery';
import { paginatedApiRequest } from '@glow/shared/lib/http';

export function getServices(page: number, filters: ServiceFilters = {}) {
  return paginatedApiRequest<Service[]>(
    'get',
    filters.specializationId !== undefined
      ? `/specializations/${filters.specializationId}/services`
      : '/services',
    { page, name: filters.name }
  );
}

export function useGetServicesInfinite(
  filters: MaybeRef<ServiceFilters> = {},
  enabled: MaybeRef<boolean> = true
) {
  return useInfiniteQuery(
    serviceKeys.list(filters),
    ({ pageParam }) => getServices(pageParam, unref(filters)),
    {
      getNextPageParam: (lastPage) => tryGetNextPage(lastPage.meta!),
      enabled: computed(
        () => unref(enabled) && (unref(filters).name?.length ?? 0) >= 3
      ),
    }
  );
}
